import React from 'react';
import Navbar from '../../components/Navbar';
import { FileText, ChevronRight } from 'lucide-react';

const TermsOfService = () => {
    return (
        <div className="bg-[#0b0e11] min-h-screen text-gray-100 font-sans selection:bg-blue-500/30">
            <Navbar />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="text-center mb-16">
                    <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Terms of Service</h1>
                    <p className="text-gray-400 max-w-2xl mx-auto">
                        Please read these terms and conditions carefully before using our service.
                    </p>
                    <div className="mt-4 text-sm text-gray-500">
                        Last Updated: February 2026
                    </div>
                </div>

                <div className="bg-[#181a20] rounded-3xl p-8 sm:p-12 border border-gray-800 space-y-12">

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">1.</span> Acceptance of Terms
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                By accessing and using the services provided by Albatech ("we," "us," or "our"), you agree to comply with and be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                            </p>
                            <p>
                                We reserve the right to modify these terms at any time. Your continued use of the service after any such changes constitutes your acceptance of the new Terms of Service.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">2.</span> Eligibility
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                To use our services, you must be at least 18 years old and have the legal capacity to enter into a binding contract. You represent and warrant that you are not on any trade or economic sanctions lists.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">3.</span> Account Registration
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                You must create an account to use our services. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.
                            </p>
                            <p>
                                You are responsible for safeguarding your password and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">4.</span> Identity Verification
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                We are required to comply with Know Your Customer (KYC) and Anti-Money Laundering (AML) laws. You agree to provide us with the information we request for the purposes of identity verification and the detection of money laundering, terrorist financing, fraud, or any other financial crime.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">5.</span> Trading Risks
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                Trading cryptocurrencies involves significant risk and can result in the loss of your capital. You should not invest more than you can afford to lose and should ensure that you fully understand the risks involved.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">6.</span> Fees
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                You agree to pay the fees for trades completed via our services as set forth in our Fee Schedule, which we may revise from time to time. Changes to the Fee Schedule are effective as of the effective date indicated in the Fee Schedule updates.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                            <span className="text-blue-500">7.</span> Limitation of Liability
                        </h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed">
                            <p>
                                To the maximum extent permitted by applicable law, in no event will Albatech, its affiliates and their respective shareholders, members, directors, officers, employees, attorneys, agents, representatives, suppliers or contractors be liable for any incidental, indirect, special, punitive, consequential or similar damages or liabilities whatsoever.
                            </p>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
